import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import {SectorsGrid} from '../components/index';

const SectorsPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Sectores</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <SectorsGrid />
    </>
  );
};

export default SectorsPage;
